export enum TractorMake {
    Uknown = -1,
    Ottawa = 0,
    International = 1,
    Freightliner = 2,
    Volvo = 3,
    Mac = 4,
    Kenworth = 5,
    Peterbuilt = 6,
    WesternStar = 7,
    Autocar = 8
}

export const TractorMakeMetadata = {
    '-1': {
        display: 'Unknown',
        value: -1
    },
    '0': {
        display: 'Ottawa',
        value: 0
    },
    '1': {
        display: 'International',
        value: 1
    },
    '2': {
        display: 'Freightliner',
        value: 2
    },
    '3': {
        display: 'Volvo',
        value: 3
    },
    '4': {
        display: 'Mac',
        value: 4
    },
    '5': {
        display: 'Kenworth',
        value: 5
    },
    '6': {
        display: 'Peterbuilt',
        value: 6
    },
    '7': {
        display: 'Western Star',
        value: 7
    },
    '8': {
        display: 'Autocar',
        value: 8
    }
};
